var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountDepositAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19922 6.37082V5.2C7.19922 4.53726 7.73646 4 8.39922 4H18.7992C19.462 4 19.9992 4.53726 19.9992 5.2V15.6C19.9992 16.2628 19.462 16.8 18.7992 16.8H17.6062",
    stroke: "#B3BCD2",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 6.39844H5.2C4.53726 6.39844 4 6.9357 4 7.59844V18.7984C4 19.4612 4.53726 19.9984 5.2 19.9984H16.4C17.0627 19.9984 17.6 19.4612 17.6 18.7984V7.59844C17.6 6.9357 17.0627 6.39844 16.4 6.39844Z",
    stroke: "#B3BCD2",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77344 11.6428L11.8904 9.43899C12.4711 8.85831 13.4253 8.87112 14.0218 9.46756C14.6182 10.064 14.631 11.0182 14.0503 11.5989L13.2863 12.408",
    stroke: "#B3BCD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78639 13.8984C7.58227 14.1026 7.16019 14.5102 7.16019 14.5102C6.57951 15.0908 6.56375 16.1258 7.16019 16.7222C7.75663 17.3186 8.71083 17.3314 9.29151 16.7508L11.3572 14.8754",
    stroke: "#B3BCD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86598 13.7329C9.58894 13.4558 9.43782 13.1016 9.41362 12.7434C9.3857 12.3306 9.52646 11.9125 9.83742 11.6016",
    stroke: "#B3BCD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3281 12.7422C11.9246 13.3386 11.9374 14.2929 11.3567 14.8735",
    stroke: "#B3BCD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDepositAddress);
export default __webpack_public_path__ + "static/media/account-deposit-address.aad29f0043a65c04d7050188dca172e1.svg";
export { ForwardRef as ReactComponent };